
export default {
    price (collective, unit, bid) {
        if (collective) {
            let sum = 0;
            bid.calculations.forEach(site => {
                const price = site.priceRecommended ? site.priceRecommended : site.priceOriginal ? site.priceOriginal : 0;
                sum = sum + price;
            });

            return sum;
        }

        const unitData = bid.calculations.find (d => d.unit.id === unit.id);
        if (unitData) {
            return unitData.priceRecommended ? unitData.priceRecommended : unitData.priceOriginal;
        }
    },
}